import {useMutation, useQuery} from "@apollo/client";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {
  GQL_CHECKS_QUERY2,
  GQL_SERVICE_MAINTENANCE_STATE,
  GQL_UPDATE_MAINTENANCE_SCHEDULE_V2,
  ServiceMaintenanceStateResponse,
} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkSetMaintenanceFormV2} from "@/pages/checks/list/actions/bulkSetMaintenance/BulkSetMaintenanceFormV2.tsx";
import {CheckMaintenanceV2FormValues} from "@/pages/checks/update/CreateCheckForm.types.ts";

export interface BulkSetMaintenanceV2ModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkSetMaintenanceModalV2 = ({
  selectedItemsIds,
  show,
  setShow,
  onSuccess,
}: BulkSetMaintenanceV2ModalProps) => {
  const [updateChecks, {loading: updateLoading}] = useMutation<GraphQLResponse<null>>(
    GQL_UPDATE_MAINTENANCE_SCHEDULE_V2,
    {
      refetchQueries: [GQL_CHECKS_QUERY2],
    }
  );

  const handleSubmit = async (data: CheckMaintenanceV2FormValues) => {
    const response = await updateChecks({
      variables: {
        ids: selectedItemsIds,
        data: data,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const {data, loading} = useQuery<ServiceMaintenanceStateResponse>(GQL_SERVICE_MAINTENANCE_STATE, {
    variables: {
      include: selectedItemsIds,
    },
  });
  const formId = "BulkSetMaintenanceModalFormV2";
  return (
    <FormModal
      size="lg"
      disabled={loading || updateLoading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={"Run Maintenance"}
    >
      <BulkSetMaintenanceFormV2
        services={data?.serviceMaintenanceStates.items}
        formId={formId}
        onSubmit={handleSubmit}
        onError={console.log}
      />
    </FormModal>
  );
};
